import React, { useState, useContext } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import EventInfoCard from './EventInfoCard';
import EventReminder from './EventReminder';

// mutations
import AddReminderFoEventMutation from '../../../mutations/AddReminderForEventMutation';
import SubscribeToNewsletterMutation from '../../../mutations/SubscribeToNewsletterMutation';
import { HelpdeskWidgetContext } from '../HelpdeskWidget'


const EventPendingView = (props) => {

  const [reminderResultSuccessful, setReminderResultSuccessful] = useState(false);
  const [showReminderResult, setShowReminderResult] = useState(false);
  const [newsletterResultStatus, setNewsletterResultStatus] = useState(null);
  const [showNewsletterResult, setShowNewsletterResult] = useState(false);
  const [hlpDskState, hlpDskDispatch] = useContext(HelpdeskWidgetContext);

  const handleRequestReminder = (email, startnumber, raceletter) => {
    hlpDskDispatch({ type: "addToHistory", payload: `add to reminder SN: ${startnumber}` })
    const { pendingEvent, intl, relay } = props;
    AddReminderFoEventMutation.commit(
      relay.environment,
      email,
      pendingEvent.id,
      intl.locale,
      startnumber,
      (err, status) => {
        if (err) {
          return;
        }
        if (status === 'ok') {
          setReminderResultSuccessful(true);
          setShowReminderResult(true);
        }
      }
    );
    if (raceletter) {
      handleSubscribeToRaceletter(email);
    }
  };

  const handleSubscribeToRaceletter = (email) => {
    const { pendingEvent, intl, relay } = props;
    SubscribeToNewsletterMutation.commit(
      relay.environment,
      email,
      intl.locale,
      pendingEvent.sports[0]?.name,
      (err, status) => {
        if (err) {
          return;
        }
        setNewsletterResultStatus(status);
        setShowNewsletterResult(true);
      }
    );
  };

  const { pendingEvent, ...rest } = props;

  return (
    <div className="row event-pending-container">
      <EventInfoCard eventInfo={pendingEvent} {...rest} />
      <EventReminder
        showReminderResult={showReminderResult}
        reminderResultSuccessful={reminderResultSuccessful}
        showNewsletterResult={showNewsletterResult}
        newsletterResultStatus={newsletterResultStatus}
        onRequestReminder={handleRequestReminder}
      />
    </div>
  );
}

EventPendingView.propTypes = {
  bestOfAvailable: PropTypes.bool,
  pendingEvent: PropTypes.object,
  intl: PropTypes.object,
  relay: PropTypes.object,
  onExpandBestof: PropTypes.func,
};

export { EventPendingView };

export default createFragmentContainer(injectIntl(EventPendingView), {
  pendingEvent: graphql`
    fragment EventPendingView_pendingEvent on Event {
      id
      sgId
      name
      sports {
        name
      }
      ...EventInfoCard_eventInfo
    }
  `,
});
